import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import SbEditable from "storyblok-react"
import Helmet from "react-helmet"

import Components from "./../Components"
import Image from "./../Image"
import Batch from "./../Batch"

import styles from "./styles.module.scss"

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const BlogPost = (props) => {
  const [author, setAuthor] = useState(null)

  const renderDate = (date) => {
    let dateArr = date.split("-")
    let dayArr = dateArr[2].split(" ")
    let dateStr = `${dayArr[0]} ${months[dateArr[1] - 1]} ${dateArr[0]}`

    return dateStr
  }

  const { teamMembers, blogPosts } = useStaticQuery(graphql`
    query {
      teamMembers: allStoryblokEntry(
        filter: { field_component: { eq: "member" } }
      ) {
        nodes {
          uuid
          slug
          content
        }
      }
      blogPosts: allStoryblokEntry(
        filter: { field_component: { eq: "blogpost" } }
      ) {
        nodes {
          uuid
          slug
          content
        }
      }
    }
  `)

  useEffect(() => {
    const memberData = teamMembers.nodes.find((member) => {
      return member.uuid == props.blok.author
    })

    if (!memberData) {
      setAuthor(null)
    } else if (!memberData && !memberData.content) {
      setAuthor(null)
    } else {
      setAuthor(JSON.parse(memberData.content))
    }
  }, [])

  const renderAuthor = () => {
    if (!author) return
    return (
      <div className={styles["blogpost__author-wrapper"]}>
        {author.image.filename && (
          <img
            src={author.image.filename}
            className={styles["blogpost__author-image"]}
            alt={author.image.alt}
          />
        )}
        <div className={styles["blogpost__author-info"]}>
          <span className={`body ${styles["blogpost__author-name"]}`}>
            <b>{author.name}</b>
          </span>
          <span className={`body ${styles["blogpost__author-title"]}`}>
            {author.title}
          </span>
        </div>
      </div>
    )
  }

  return (
    <SbEditable content={props.blok}>
      <Helmet
        title={`Equalize Health - ${props.blok.title}`}
        meta={[
          {
            name: "title",
            content: `${props.blok.metadata.title || props.blok.title}`,
          },
          {
            name: "description",
            content: `${
              props.blok.metadata.description || props.blok.preview_text
            }`,
          },
          {
            name: "keywords",
            content: `${props.blok.metadata.keywords || ""}`,
          },
          {
            name: "image",
            content: `${
              props.blok.teaser[0].images[0].asset.filename ||
              "https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg"
            }`,
          },
          {
            name: "twitter:title",
            content: `${props.blok.metadata.title || props.blok.title}`,
          },
          {
            name: "twitter:description",
            content: `${
              props.blok.metadata.description || props.blok.preview_text
            }`,
          },
          {
            name: "twitter:keywords",
            content: `${props.blok.metadata.keywords || ""}`,
          },
          {
            name: "twitter:card",
            content: `summary_large_image`,
          },
          {
            name: "twitter:image",
            content: `${
              props.blok.teaser[0].images[0].asset.filename ||
              "https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg"
            }`,
          },
          {
            name: "og:title",
            content: `${props.blok.metadata.title || props.blok.title}`,
          },
          {
            name: "og:description",
            content: `${
              props.blok.metadata.description || props.blok.preview_text
            }`,
          },
          {
            name: "og:keywords",
            content: `${props.blok.metadata.keywords || ""}`,
          },
          {
            name: "og:image",
            content: `${
              props.blok.teaser[0].images[0].asset.filename ||
              "https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg"
            }`,
          },
          {
            name: "image",
            property: "og:image",
            content: `${
              props.blok.teaser[0].images[0].asset.filename ||
              "https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg"
            }`,
          },
        ]}
      />
      {props.blok.teaser &&
        props.blok.teaser.map((blok) =>
          React.createElement(Components(blok.component), {
            key: blok._uid,
            blok: blok,
          })
        )}
      <section className={styles["blogpost__header"]}>
        <div className="container">
          <div className={`row ${styles["blogpost__header-row"]}`}>
            <div
              className={`col-12 col-sm-8 ${styles["blogpost__header-heading"]}`}
            >
              <h2 className={`heading-3`}>
                <b>{props.blok.title}</b>
              </h2>
              <span className={`heading-5 ${styles["blogpost__header-date"]}`}>
                {renderDate(props.blok.date)}
              </span>
            </div>
            <div
              className={`col-12 col-sm-4 ${styles["blogpost__header-author"]}`}
            >
              {author && renderAuthor()}
            </div>
          </div>
        </div>
        {props.blok.batch && (
          <Batch
            blok={props.blok.batch}
            className={styles["blogpost__batch"]}
          />
        )}
      </section>
      {props.blok.body && props.blok.body.length == 0 ? (
        <div className={styles["blogpost__add-components"]}>
          <p className="body">Please add some components..</p>
        </div>
      ) : (
        <div className={styles["blogpost__body"]}>
          {props.blok.body &&
            props.blok.body.map((blok) =>
              React.createElement(Components(blok.component), {
                key: blok._uid,
                blok: blok,
                className: styles["blogpost__body"],
              })
            )}
          <section className={`container ${styles["blogpost__footer"]}`}>
            {author && renderAuthor()}
          </section>
        </div>
      )}
    </SbEditable>
  )
}

export default BlogPost
